export default "__VITE_ASSET__DqPJrqC8__"